import { Skeleton } from "@/components/skeletons/Skeleton";

export function VoiceModelSkeleton({ amount }: { amount: number }) {
  return (
    <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
      {Array.from({ length: amount }).map((_, index) => (
        <Skeleton key={index} className="h-[180px] w-full rounded-3xl" />
      ))}
    </div>
  );
}
